import { Copyright, StyledMediaIcon } from '../styled';

const data = [
  {
    platform: 'facebook',
    link: 'https://www.facebook.com/lms360elearning'
  },
  {
    platform: 'youtube',
    link: 'https://www.youtube.com/@lms360elearning-pg8ps'
  },
  {
    platform: 'tiktok',
    link: 'https://www.tiktok.com/@bk.tech360'
  }
];

const FooterBottom = () => (
  <Copyright>
    Copyright ©2021 - Bản quyền thuộc Công Ty Cổ Phần Tập Đoàn Khoa Học Công
    Nghệ Bách Khoa
    <div className="flex justify-center align-items-center gap-10">
      {data.map(item => (
        <a
          key={item.platform}
          href={item.link}
          target="_blank"
          rel="noreferrer">
          <StyledMediaIcon
            src={
              process.env.REACT_APP_STATIC_URL +
              `content/assets/images/${item.platform}.png`
            }
            alt={item.platform}
          />
        </a>
      ))}
    </div>
  </Copyright>
);

export default FooterBottom;
